import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";

AxiosCurlirize(axios, () => {});

export interface IBulkUpdatePersonaDiscountResponse {
  status: boolean;
  message: string;
  total_rows?: number;
  updated_count?: number;
}

export const useBulkUpdatePersonaDiscountAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { enable, disable } = useLoaderActions("isBulkUploadInProgress");

  const execute = useCallback(
    async (file: File): Promise<{ status: boolean; data: IBulkUpdatePersonaDiscountResponse | null }> => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const formData = new FormData();
        formData.append("file", file);

        const response = await axios
          .post(`${INVENTORY_MODULE?.BULK_UPDATE_PERSONA_DISCOUNT?.baseURL}`, formData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res: AxiosResponse<IBulkUpdatePersonaDiscountResponse>) => {
            const payload = res.data;
            if (payload?.status === true) {
              toast.success(payload.message || "Bulk persona discount update completed successfully");
              return { status: true, data: payload };
            } else {
              toast.error(payload.message || "Bulk persona discount update failed");
              return { status: false, data: payload };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            captureError(e);
            const errorData = e.response?.data as any;
            const message = errorData?.message || "Failed to upload. Please try again.";
            toast.error(message);
            return { status: false, data: errorData || null };
          });

        disable();
        return response;
      } catch (e: any) {
        disable();
        toast.error("Server Error: " + e.message);
        return { status: false, data: null };
      }
    },
    [dispatch, configuration, captureError, sendCurl, enable, disable],
  );

  return { execute };
};
